import { TOGGLE_IMITATION } from '../actions/types';

const initialState = false;

export default function(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_IMITATION:
      return !state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/toggleReducer.js